import React from 'react';
import { LogoProps } from './types';

function ShieldEmpty({ width, height, color }: LogoProps) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 20 21" fill="none">
      <g clipPath="url(#clip0_102_2838)">
        <path
          d="M3.5 9.66667V5.31654L10 2.42765L16.5 5.31654V9.66667C16.5 13.7846 13.6965 17.6017 10 18.6332C6.30345 17.6017 3.5 13.7846 3.5 9.66667Z"
          stroke={color}
          strokeWidth="2"
        />
        <path
          d="M8.88922 12.0444L7.34477 10.5L6.81885 11.0222L8.88922 13.0926L13.3337 8.64815L12.8114 8.12593L8.88922 12.0444Z"
          fill={color}
          stroke={color}
          strokeWidth="0.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_102_2838">
          <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default ShieldEmpty;
